@if (tableLabel) {
    <h3 class="mat-headline-6" id="label">{{ tableLabel }}</h3>
}
<div class="container mat-body-2"
     [cbInfiniteScroll]="cbTableRef"
     [fetch]="fetch"
     [queryUpdated]="queryUpdated"
     [enabled]="infiniteScrollEnabled"
     [fetchInProgress]="fetchInProgress"
     (fetchInProgressChange)="fetchInProgressChange.emit($event)"
     [results]="results"
     (resultsChange)="resultsChange.emit($event)"
     [currentPage]="currentPage"
     (currentPageChange)="currentPageChange.emit($event)">
    <div class="scroll-container"
         [ngStyle]="{'min-width': minWidthStyle, 'max-height': getMaxHeight}">
        <ng-content select="[cbTable]"></ng-content>
        <table [hidden]="hideDefaultTable"
               #cbTableRef>
            <ng-content select="[cbTableHead]"></ng-content>
            @if (objectColumns?.length || stringColumns?.length) {
                <thead>
                    @if (!isStringTypeColumn) {
                        <tr>
                            @for (col of objectColumns; track col) {
                                <td
                                    [style.width.px]="col.width"
                                    [style.minWidth.px]="col.minWidth"
                                    [style.maxWidth.px]="col.maxWidth"
                                    [style.textAlign]="col.textAlign">
                                    {{ col.label || '' }}
                                </td>
                            }
                        </tr>
                    }
                    @if (isStringTypeColumn) {
                        <tr>
                            @for (col of stringColumns; track col) {
                                <td>
                                    {{ col }}
                                </td>
                            }
                        </tr>
                    }
                </thead>
            }

            <ng-content select="[cbTableFoot]"></ng-content>
            <tfoot>
            <ng-content select="[cbTableFooterRow]"></ng-content>
            </tfoot>

            <ng-content select="[cbTableBody]"></ng-content>
            <tbody #cbTableRowBody>
            <ng-content select="[cbTableRow]"></ng-content>
            </tbody>

            <tbody>
                @if (displayNoResultsMessage(cbTableRowBody)) {
                    <tr
                        class="cb-table-footer-row">
                        <td colspan="100%">
                            @if (displayNoResultsMessage(cbTableRowBody)) {
                                <cb-info-message
                                    [message]="emptyMessage || 'There are no '+ (label || 'items') +' to display'"
                                    [icon]="'info'"></cb-info-message>
                            }
                        </td>
                    </tr>
                }

                @if (!loaded || fetchInProgress) {
                    <tr
                        class="cb-table-footer-row">
                        <td colspan="100%">
                            <cb-loading-spinner></cb-loading-spinner>
                        </td>
                    </tr>
                }
            </tbody>

            <tbody>

            </tbody>
        </table>
    </div>
</div>
